import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styles';
import Estrela from '../../assets/emojis/aval/estrela.png';
import AvalEstrela from '../../assets/emojis/aval/aval-estrela4x.png';
import AvalEstrelaIncolor from '../../assets/emojis/aval/aval-estrela-branco.png';
import MeiaEstrela from '../../assets/emojis/aval/meia-estrela.png';
import Produto from '../../assets/emojis/aval/produto.png';
import Entrega from '../../assets/emojis/entrega/entrega@3x.png';
import Hand from '../../assets/emojis/aval/hand.png';
import User from '../../assets/emojis/aval/user.png';
import Hamburguer from '../../assets/emojis/aval/hamburguer.png';
import Moto from '../../assets/emojis/aval/moto.png';
import Arrow from '../../assets/emojis/aval/arrow.png';
import ArrowLeft from '../../assets/emojis/aval/arrow-left.png';
import { FiChevronDown } from 'react-icons/fi';
import api from '../../services/api';

export default class Avaliacoes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carregou: true,
            media: 0,
            mediaProduto: 0,
            mediaTempoEntrega: 0,
            rest_id: '',
            vendas: [],
            currentPage: 1,
            itemsPerPage: 10,
            count: 0,
            fetchData: () => { }
        }
    }
    async fetchData() {

        const restDataString = window.localStorage.getItem('@rest')
        const restData = JSON.parse(restDataString)
        const restId = restData.id
        this.setState({ rest_id: restId })
  
        try {
            const restDataString = window.localStorage.getItem('@rest')
            const restData = JSON.parse(restDataString)
            const restId = restData.id
            this.setState({ rest_id: restId })

            await api.post(`/api/avaliacaoRestaurante`,{ rest_id: restId || this.state.rest_id },{
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('@jwt')}`
                    }
                })
                .then(res => {
                    console.log(res.data.result)
                    if (res.data && res.data.result && res.data.result.length > 0) {
                        const primeiroItem = res.data.result[0]
                        const media = parseFloat(primeiroItem.media.replace(',', '.'))
                        const mediaProduto = parseFloat(primeiroItem.media_produto.replace(',', '.'))
                        const mediaTempoEntrega = parseFloat(primeiroItem.media_tempo_entrega.replace(',', '.'))
                        this.setState({
                            media: media?.toFixed(1).replace('.', ','),
                            mediaProduto: mediaProduto?.toFixed(1).replace('.', ','),
                            mediaTempoEntrega: mediaTempoEntrega?.toFixed(1).replace('.', ',')
                        });
                    }
                }).catch(error => console.log(error))
        } catch (error) { console.error('Error:', error) }

        try {
            await api.post(`/api/todasAvaliacoes?page=${this.state.currentPage}`,{
                rest_id: this.state.rest_id},{
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('@jwt')}`
                    }
                })
                .then(res => {
                    this.setState({ vendas: res.data.result, count: res.data.count[0].count })
                }).catch(error => console.log(error))
        } catch (error) { console.error('Error:', error) }
    }

    async componentDidMount() {
        this.fetchData()
    }

    handleClickPrev = () => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('page', this.state.currentPage - 1);
        const newUrl = window.location.pathname + '?' + searchParams.toString();
        window.history.pushState(null, '', newUrl);

        this.setState({
            currentPage: this.state.currentPage - 1,
        }, () => {
            this.fetchData();
        });
    };

    handleClickNext = () => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('page', this.state.currentPage + 1);
        const newUrl = window.location.pathname + '?' + searchParams.toString();
        window.history.pushState(null, '', newUrl);

        this.setState({
            currentPage: this.state.currentPage + 1,
        }, () => {
            this.fetchData();
        });
    };

    render() {
        // logica das estrelas
        const mediaFloat = this.state.media ? parseFloat(this.state.media.replace(',', '.')) : 0;
        const mediaProdutoFloat = this.state.mediaProduto ? parseFloat(this.state.mediaProduto.replace(',', '.')) : 0;
        const mediaEntregaFloat = this.state.mediaTempoEntrega ? parseFloat(this.state.mediaTempoEntrega.replace(',', '.')) : 0;

        const mediaRounded = mediaFloat.toFixed(1);
        const produtoMediaRounded = mediaProdutoFloat.toFixed(1);
        const entregaMediaRounded = mediaEntregaFloat.toFixed(1);

        const starCount = Math.floor(mediaRounded);
        const produtoStarCount = Math.floor(produtoMediaRounded);
        const entregaStarCount = Math.floor(entregaMediaRounded);

        const hasHalfStar = (mediaRounded - starCount) >= 0.5;
        const hasHalfStarProduto = (produtoMediaRounded - produtoStarCount) >= 0.5;
        const hasHalfStarEntrega = (entregaMediaRounded - entregaStarCount) >= 0.5;

        const emptyStarCount = 5 - starCount - (hasHalfStar ? 1 : 0);
        const emptyProdutoStarCount = 5 - produtoStarCount - (hasHalfStarProduto ? 1 : 0);
        const emptyEntregaStarCount = 5 - entregaStarCount - (hasHalfStarEntrega ? 1 : 0);

        // paginacao

        const lastPage = this.state.count <= 10 ? 1 : Math.ceil(this.state.count / this.state.itemsPerPage)
        return (
            <Container>

                {this.state.carregou ?
                    <div className="div-pai">
                        <div className="div-rota">

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/'}>
                                <span
                                    className="rotas" >
                                    Início
                                </span>
                            </Link>

                            <span className="rotas"> {'>'} </span>

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/avaliacoes'}>
                                <span>
                                    Avaliações
                                </span>
                            </Link>

                        </div>

                        <img alt="" className="emoji" src={Estrela} />

                        <h1>Avaliações</h1>

                        <h5>Acompanhe suas avaliações nos ultimos <span className='bold'>90</span> dias.</h5>

                        <hr className="linha" />

                        <div className='posicao'>
                            <h3>Notas do restaurante</h3>

                            <div className='row1'>
                                <div className='borda'>
                                    <div className='nota'>
                                        <span> {this.state.media}</span>


                                        <div className="star1">
                                            {[...Array(starCount)].map((_, i) => (
                                                <img alt="" className="star" src={AvalEstrela} key={i} />
                                            ))}
                                            {hasHalfStar && (
                                                <img alt="" className="star" src={MeiaEstrela} key="half-star" />
                                            )}
                                            {[...Array(emptyStarCount)].map((_, i) => (
                                                <img
                                                    alt=""
                                                    className="star"
                                                    src={AvalEstrelaIncolor}
                                                    key={i + starCount + (hasHalfStar ? 1 : 0)}
                                                />
                                            ))}
                                        </div>

                                        <div className='conteudo'>
                                            <div>
                                                <img alt="" className="icone" src={Estrela} />
                                            </div>

                                            <div className='descricao'>
                                                <span>Nota do restaurante</span>
                                            </div>
                                        </div>
                                        {/* <div className='descricao'>
                                            <span> {this.state.count} avaliações nos últimos 90 dias</span>
                                        </div> */}
                                    </div>
                                </div>

                                <div className='borda2'>
                                    <div className='nota'>
                                        <span> {this.state.mediaProduto}</span>

                                        <div className="star1">
                                            {[...Array(produtoStarCount)].map((_, i) => (
                                                <img alt="" className="star" src={AvalEstrela} key={i} />
                                            ))}
                                            {hasHalfStarProduto && (
                                                <img alt="" className="star" src={MeiaEstrela} key="half-star" />
                                            )}
                                            {[...Array(emptyProdutoStarCount)].map((_, i) => (
                                                <img
                                                    alt=""
                                                    className="star"
                                                    src={AvalEstrelaIncolor}
                                                    key={i + produtoStarCount + (hasHalfStarProduto ? 1 : 0)}
                                                />
                                            ))}
                                        </div>

                                        <div className='conteudo'>
                                            <div>
                                                <img alt="" className="icone" src={Produto} />
                                            </div>

                                            <div className='descricao'>
                                                <span>Produto</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='borda2'>
                                    <div className='nota'>
                                        <span>{this.state.mediaTempoEntrega}</span>

                                        <div className="star1">
                                            {[...Array(entregaStarCount)].map((_, i) => (
                                                <img alt="" className="star" src={AvalEstrela} key={i} />
                                            ))}
                                            {hasHalfStar && (
                                                <img alt="" className="star" src={MeiaEstrela} key="half-star" />
                                            )}
                                            {[...Array(emptyEntregaStarCount)].map((_, i) => (
                                                <img
                                                    alt=""
                                                    className="star"
                                                    src={AvalEstrelaIncolor}
                                                    key={i + entregaStarCount + (hasHalfStarEntrega ? 1 : 0)}
                                                />
                                            ))}
                                        </div>

                                        <div className='conteudo'>
                                            <div>
                                                <img alt="" className="icone" src={Entrega} />
                                            </div>

                                            <div className='descricao'>
                                                <span>Tempo de entrega</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='aval-mobile'>
                                <span>Avaliação dos clientes</span>
                            </div>

                            <div className='borderPink'>
                                <div>
                                    <img alt="" className="hand" src={Hand} />
                                </div>

                                <span className='coments'>Os comentários que os clientes estão fazendo somente o restaurante e o cliente pode visualizar.
                                    <br />
                                    Esses comentários não vão estar disponíveis para visualização de outros clientes no aplicativo.
                                </span>
                            </div>

                            <div className='paginacao'>
                                <span>Exibindo</span>
                                <span className="paginas"> {this.state.vendas?.length}</span>
                                <span> resultados de</span>
                                <span className="paginas"> {this.state.count} </span>
                            </div>

                            {this.state.vendas.map(venda => {
                                const date = new Date(venda?.vendas_created);
                                const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} às ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
                                const media = venda?.nota_media || 0;
                                const fullStars = Math.floor(media);
                                const decimal = media - fullStars;
                                const hasHalfStar = decimal >= 0.5;
                                const emptyStars = Math.floor(5 - media);

                                return (
                                    <div className='borda3'>
                                        <div className='conteudo'>
                                            <img alt="" className="user" src={User} />
                                            <div className='coluna'>
                                                <span className='userName'>{venda?.user_nome}</span>
                                                <div className='row-mobile'>
                                                    <span className='subtexto'>#{venda?.chave_pedido} ・ </span>
                                                    <span className='subtexto'>{formattedDate}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <div className='row-mobile'>
                                                <img alt="" className="sub_icone" src={Hamburguer} />
                                                <span className='subtexto1'>{venda?.nota_produto.toString().replace('.', ',') || 0}</span>
                                                <img alt="" className="sub_icone" src={Moto} />
                                                <span className='subtexto1'>{venda?.nota_tempo_entrega.toString().replace('.', ',') || 0}</span>
                                                {[...Array(fullStars)].map((_, i) => (
                                                    <img alt="" className="star_coments" src={AvalEstrela} key={`full_star_${i}`} />
                                                ))}
                                                {hasHalfStar && <img alt="" className="star_coments" src={MeiaEstrela} />}
                                                {[...Array(emptyStars)].map((_, i) => (
                                                    <img alt="" className="star_coments" src={AvalEstrelaIncolor} key={`empty_star_${i}`} />
                                                ))}


                                            </div>
                                        </div>
                                        {venda?.feedback ?
                                            <>
                                                <span className='comentario'>Comentário</span>
                                                <div className='borda4'>
                                                    <span className='subtexto'>{venda?.feedback}</span>
                                                </div>
                                            </>
                                            :
                                            null}

                                    </div>
                                );
                            })}

                            <div className="paginacaoEnd">
                                {lastPage > 1 && this.state.currentPage > 1 && (
                                    <button className="button" onClick={this.handleClickPrev}>
                                        <img alt="" className="arrow" src={ArrowLeft} />
                                        Voltar
                                    </button>
                                )}

                                <span className="paginas1">{this.state.currentPage}</span>
                                <span style={{ marginRight: 27 }}> de </span>
                                <span className="paginas1"> {Number(lastPage)}</span>

                                {lastPage > 1 && this.state.currentPage < lastPage && (
                                    <button className="button1" onClick={this.handleClickNext}>
                                        Seguinte
                                        <img alt="" className="arrow" src={Arrow} />
                                    </button>
                                )}
                            </div>


                            {/* <div className="paginacaoEnd">
                                <button className="button" onClick={this.handleClickPrev} disabled={this.state.currentPage === 1}>
                                    <img alt="" className="arrow" src={ArrowLeft} />
                                    Voltar
                                </button>

                                <span className="paginas1">{this.state.currentPage}</span>
                                <span style={{marginRight: 27}}> de </span>
                                <span className="paginas1"> {Number(lastPage)}</span>

                                <button className="button1" onClick={this.handleClickNext} disabled={this.state.currentPage >= Number(lastPage)}>
                                    Seguinte
                                    <img alt="" className="arrow" src={Arrow} />
                                </button>
                            </div> */}
                        </div>
                    </div>

                    :

                    <div className="div-pai">
                        <div className="div-rota">

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/'}>
                                <span
                                    className="rotas" >
                                    Início
                                </span>
                            </Link>

                            <span className="rotas"> {'>'} </span>

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/aval'}>
                                <span>
                                    Avaliações
                                </span>
                            </Link>

                        </div>

                        <img alt="" className="emoji" src={Estrela} />

                        <h1>Avaliações</h1>

                        <h5>Acompanhe suas avaliações nos ultimos <span className='bold'>90</span> dias.</h5>

                        <hr className="linha" />
                        <div className='posicao'>
                            <h3>Notas do restaurante</h3>

                            <div className='row1'>
                                <div className='borda'>
                                    <div className='nota'>
                                        <span> 0.0</span>

                                        <div className='star'>
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                        </div>


                                        <div className='descricao'>
                                            <span>0 avaliações nos últimos 90 dias</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='borda2'>
                                    <div className='nota'>
                                        <span> 0.0</span>

                                        <div className='star'>
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                        </div>

                                        <div className='conteudo'>
                                            <div>
                                                <img alt="" className="icone" src={Produto} />
                                            </div>

                                            <div className='descricao'>
                                                <span>Produto</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='borda2'>
                                    <div className='nota'>
                                        <span> 0.0</span>

                                        <div className='star'>
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                            <img alt="" className="star" src={AvalEstrelaIncolor} />
                                        </div>

                                        <div className='conteudo'>
                                            <div>
                                                <img alt="" className="icone" src={Entrega} />
                                            </div>

                                            <div className='descricao'>
                                                <span>Tempo de entrega</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h3>Avaliação dos clientes</h3>

                            <div className='borderPink'>
                                <div>
                                    <img alt="" className="hand" src={Hand} />
                                </div>

                                <span className='coments'>Os comentários que os clientes estão fazendo somente o restaurante e o cliente pode visualizar.
                                    <br />
                                    Esses comentários não vão estar disponíveis para visualização de outros clientes no aplicativo.
                                </span>
                            </div>

                            <div className='textonull'>
                                <span>Seu restaurante ainda não possui avaliações.</span>
                            </div>


                            {/* <div className="paginacaoEnd">
                                <span className="paginas1">{this.state.currentPage}</span>
                                <span style={{marginRight: 27}}> de </span>
                                <span className="paginas1"> 1 </span>
                            </div> */}

                            <div className="paginacaoEnd">
                                {lastPage > 1 && this.state.currentPage > 1 && (
                                    <button className="button" onClick={this.handleClickPrev}>
                                        <img alt="" className="arrow" src={ArrowLeft} />
                                        Voltar
                                    </button>
                                )}

                                <span className="paginas1">{this.state.currentPage}</span>
                                <span style={{ marginRight: 27 }}> de </span>
                                <span className="paginas1"> {Number(lastPage)}</span>

                                {lastPage > 1 && this.state.currentPage < lastPage && (
                                    <button className="button1" onClick={this.handleClickNext}>
                                        Seguinte
                                        <img alt="" className="arrow" src={Arrow} />
                                    </button>
                                )}
                            </div>



                        </div>
                    </div>

                }
            </Container>
        )
    }
}